/**
 * Section template icon - 4-pointed star with circle and plus sign
 * Used for Blank and Curated section type cards
 */
export function SectionIcon() {
  return (
    <div className="flex items-center justify-center w-14 h-14 bg-secondary rounded-xl">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* 4-pointed star outline */}
        <path
          d="M16 4C16 4 18 12 18 14C18 14 26 14 26 16C26 16 18 16 18 18C18 18 16 26 16 28C16 28 14 18 14 18C14 18 6 16 6 16C6 16 14 14 14 14C14 14 16 4 16 4Z"
          stroke="var(--primary)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        {/* Small circle bottom-left */}
        <circle cx="9" cy="24" r="2.5" stroke="var(--primary)" strokeWidth="2" fill="none" />
        {/* Plus sign top-right */}
        <path d="M25 5V9M23 7H27" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
}

/**
 * Blank icon - canvas/easel presentation frame
 */
export function BlankIcon() {
  return (
    <div className="flex items-center justify-center w-14 h-14 bg-secondary rounded-xl">
      <svg
        width="36"
        height="36"
        viewBox="0 0 49 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M29.335 7.07999H43.505C44.0354 7.07999 44.5441 7.2907 44.9192 7.66577C45.2943 8.04084 45.505 8.54955 45.505 9.07999V31.35H3.005V9.10999C3.005 8.57955 3.21563 8.07084 3.5907 7.69577C3.96577 7.3207 4.47457 7.10999 5.005 7.10999H19.1749"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.2749 35.43V47.57M8.08496 47.57L14.1549 35.42M40.465 47.57L34.3949 35.42M24.2749 1V5.04999M29.335 7.07999C29.335 7.61042 29.1242 8.11913 28.7491 8.4942C28.3741 8.86927 27.8654 9.07999 27.335 9.07999H21.2649C20.7278 9.07999 20.2128 8.86664 19.833 8.48688C19.4532 8.10712 19.24 7.59206 19.24 7.05499C19.24 6.51793 19.4532 6.00287 19.833 5.62311C20.2128 5.24335 20.7278 5.03 21.2649 5.03H27.335C27.6019 5.02992 27.8661 5.08324 28.1121 5.18686C28.358 5.29048 28.5807 5.44232 28.7671 5.63336C28.9535 5.82441 29.0997 6.0508 29.1973 6.29926C29.2948 6.54771 29.3416 6.81317 29.335 7.07999ZM45.5249 31.38H3.0249C2.48784 31.38 1.97278 31.5934 1.59302 31.9731C1.21326 32.3529 1 32.8679 1 33.405C1 33.9421 1.21326 34.4571 1.59302 34.8369C1.97278 35.2166 2.48784 35.43 3.0249 35.43H45.5249C46.062 35.43 46.577 35.2166 46.9568 34.8369C47.3365 34.4571 47.5499 33.9421 47.5499 33.405C47.5499 32.8679 47.3365 32.3529 46.9568 31.9731C46.577 31.5934 46.062 31.38 45.5249 31.38V31.38Z"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

/**
 * Curated icon - puzzle piece with hands
 */
export function CuratedIcon() {
  return (
    <div className="flex items-center justify-center w-14 h-14 bg-secondary rounded-xl">
      <svg
        width="36"
        height="36"
        viewBox="0 0 49 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M7.07001 47.6167L3 42.5567C1.70803 40.9414 1.00286 38.9352 1 36.8667V26.3567C1 25.561 1.31605 24.798 1.87866 24.2354C2.44127 23.6727 3.20435 23.3567 4 23.3567V23.3567C4.79565 23.3567 5.5587 23.6727 6.12131 24.2354C6.68392 24.798 7 25.561 7 26.3567V34.1967"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.18 47.6167V41.2566C16.1731 39.4742 15.6371 37.734 14.64 36.2566L12.34 32.7367C12.1493 32.4139 11.8968 32.1319 11.5969 31.9069C11.2971 31.6819 10.9558 31.5182 10.5925 31.4253C10.2293 31.3324 9.85135 31.3122 9.48027 31.3656C9.10919 31.419 8.7523 31.5451 8.43004 31.7367L8.30003 31.8266C7.72643 32.2095 7.31301 32.7893 7.13795 33.4563C6.9629 34.1234 7.03837 34.8314 7.35005 35.4466L10.12 40.0066"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.48 47.6167L45.53 42.5167C46.822 40.9013 47.5272 38.8951 47.53 36.8267V26.3567C47.53 25.561 47.2139 24.798 46.6513 24.2354C46.0887 23.6727 45.3257 23.3567 44.53 23.3567V23.3567C43.7344 23.3567 42.9713 23.6727 42.4087 24.2354C41.8461 24.798 41.53 25.561 41.53 26.3567V34.1967"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.34 47.6167V41.2567C32.3469 39.4743 32.8829 37.7341 33.88 36.2567L36.19 32.7767C36.3807 32.4539 36.6333 32.1719 36.9331 31.9469C37.233 31.7219 37.5743 31.5583 37.9375 31.4654C38.3007 31.3725 38.6787 31.3522 39.0498 31.4056C39.4209 31.459 39.7778 31.5851 40.1 31.7767L40.23 31.8667C40.8105 32.2435 41.2328 32.8199 41.417 33.4869C41.6013 34.1539 41.5348 34.8654 41.23 35.4867L38.44 40.0367"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.41 23.1167C26.6502 22.3569 26.2233 21.3263 26.2233 20.2517C26.2233 19.1771 26.6502 18.1465 27.41 17.3867C28.1699 16.6268 29.2004 16.2 30.275 16.2C31.3496 16.2 32.3802 16.6268 33.14 17.3867C33.5307 17.7827 33.8399 18.2515 34.05 18.7667C34.1087 18.9247 34.2064 19.0653 34.3341 19.1755C34.4617 19.2856 34.6151 19.3617 34.78 19.3967C34.9452 19.4341 35.1172 19.429 35.2799 19.3818C35.4425 19.3345 35.5906 19.2468 35.71 19.1267L38.87 15.9467C39.059 15.7606 39.2091 15.5388 39.3115 15.2941C39.4139 15.0495 39.4667 14.7869 39.4667 14.5217C39.4667 14.2564 39.4139 13.9939 39.3115 13.7493C39.2091 13.5046 39.059 13.2828 38.87 13.0967L35.61 9.85669C36.2691 9.65374 36.8646 9.28385 37.3385 8.7829C37.8125 8.28194 38.1489 7.66694 38.3151 6.99762C38.4812 6.3283 38.4715 5.62741 38.2869 4.96295C38.1023 4.29849 37.749 3.69303 37.2613 3.20538C36.7737 2.71774 36.1682 2.36444 35.5038 2.17981C34.8393 1.99518 34.1384 1.9855 33.4691 2.15167C32.7998 2.31784 32.1848 2.65421 31.6838 3.12817C31.1829 3.60214 30.813 4.19759 30.61 4.85669L27.37 1.59668C27.1839 1.40771 26.9621 1.25765 26.7175 1.15521C26.4728 1.05278 26.2103 1 25.945 1C25.6798 1 25.4172 1.05278 25.1726 1.15521C24.9279 1.25765 24.7061 1.40771 24.52 1.59668L21.58 4.53668C21.4754 4.64682 21.3948 4.77744 21.3431 4.92029C21.2915 5.06314 21.27 5.21514 21.28 5.3667C21.2976 5.51238 21.347 5.65236 21.4248 5.77679C21.5026 5.90123 21.6068 6.00702 21.73 6.08667C21.9565 6.24682 22.1705 6.42403 22.37 6.6167C23.1299 7.37522 23.5573 8.4045 23.5582 9.47815C23.5592 10.5518 23.1335 11.5818 22.375 12.3417C21.6165 13.1015 20.5872 13.5289 19.5135 13.5298C18.4399 13.5308 17.4099 13.1052 16.65 12.3467C16.4607 12.1459 16.29 11.9283 16.14 11.6967C15.9967 11.4769 15.7727 11.3224 15.5164 11.2662C15.2601 11.2101 14.9921 11.257 14.77 11.3967L14.58 11.5567L11.63 14.4967C11.4411 14.6828 11.291 14.9046 11.1886 15.1492C11.0861 15.3939 11.0334 15.6565 11.0334 15.9217C11.0334 16.1869 11.0861 16.4494 11.1886 16.6941C11.291 16.9387 11.4411 17.1606 11.63 17.3467L23.08 28.8067C23.2663 28.9972 23.4887 29.1486 23.7343 29.2519C23.9799 29.3552 24.2436 29.4084 24.51 29.4084C24.7765 29.4084 25.0402 29.3552 25.2858 29.2519C25.5313 29.1486 25.7538 28.9972 25.94 28.8067L29.09 25.6467C29.2125 25.5297 29.3034 25.3836 29.3539 25.222C29.4045 25.0604 29.4133 24.8885 29.3793 24.7226C29.3453 24.5567 29.2697 24.4022 29.1597 24.2734C29.0496 24.1447 28.9087 24.046 28.75 23.9867C28.2476 23.7933 27.7911 23.497 27.41 23.1167V23.1167Z"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

/**
 * Rocket icon for Quick Start section type card
 * Diagonal rocket pointing up-right at 45 degrees
 */
export function QuickStartIcon() {
  return (
    <div className="flex items-center justify-center w-14 h-14 bg-secondary rounded-xl">
      <svg
        width="36"
        height="36"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M10 28.2336L33.8 4.35355C35.4 2.75355 40.58 1.54353 43.15 1.02353C43.2815 0.994481 43.4175 0.992308 43.5499 1.01712C43.6823 1.04194 43.8083 1.09323 43.9204 1.16794C44.0324 1.24265 44.1283 1.33928 44.2021 1.45194C44.2759 1.56459 44.3262 1.69101 44.35 1.82358C44.38 1.95523 44.38 2.0919 44.35 2.22354C43.84 4.80354 42.63 9.97353 41.02 11.5835L17.19 35.4135L10 28.2336Z"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.88 25.3136L20.08 32.5236"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.02 24.5836C28.1157 27.7336 27.8743 30.8849 27.3 33.9836C26.6186 35.5964 25.638 37.0656 24.41 38.3136L19.27 43.4536C19.1766 43.5519 19.0642 43.6302 18.9395 43.6837C18.8149 43.7372 18.6807 43.7648 18.545 43.7648C18.4094 43.7648 18.2752 43.7372 18.1505 43.6837C18.0259 43.6302 17.9135 43.5519 17.82 43.4536C17.7102 43.3454 17.6269 43.2133 17.5766 43.0676C17.5263 42.9219 17.5104 42.7665 17.53 42.6136L18.53 34.0736"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8 17.3636C17.6359 17.2449 14.4681 17.4628 11.35 18.0136C9.75279 18.7398 8.30474 19.7572 7.08002 21.0136L1.95004 26.1435C1.85171 26.237 1.77339 26.3494 1.71988 26.474C1.66637 26.5987 1.63879 26.7329 1.63879 26.8686C1.63879 27.0042 1.66637 27.1384 1.71988 27.2631C1.77339 27.3877 1.85171 27.5001 1.95004 27.5936C2.0593 27.7048 2.19305 27.789 2.34064 27.8393C2.48822 27.8897 2.64554 27.9049 2.80002 27.8836L11.38 26.8335"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.86 35.4136C14.3 36.8636 13.7 38.9036 12.14 40.4736C10.58 42.0436 5.13996 43.6036 2.27996 44.3836C2.14992 44.4211 2.01363 44.4318 1.87933 44.415C1.74503 44.3983 1.61552 44.3545 1.49865 44.2863C1.38179 44.218 1.27999 44.1268 1.19943 44.018C1.11887 43.9093 1.06121 43.7853 1.02996 43.6536C0.990012 43.4859 0.990012 43.3112 1.02996 43.1436C1.79996 40.2936 3.45997 34.7236 4.90997 33.2636C6.35997 31.8036 8.51997 31.0936 9.96997 32.5336"
          stroke="var(--primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
